<nav aria-label="breadcrumb">
	<ol class="breadcrumb mb-0 rounded-0 shadow-sm px-3 py-2">
		@for(breadcrumb of (breadcrumbService.breadcrumbs$ | async); track $index){
			<li class="breadcrumb-item" [class.active]="!breadcrumb.enabled">
				@if(breadcrumb.enabled){
					@if(breadcrumb.html){
						<a [routerLink]="breadcrumb.url" [innerHtml]="breadcrumb.html" class="text-decoration-none"></a>
					}
					@else {
						<a [routerLink]="breadcrumb.url" class="text-decoration-none">{{breadcrumb.label | translate}}</a>
					}
				}
				@else {
					@if(breadcrumb.html){
						<span [innerHtml]="breadcrumb.html"></span>
					}
					@else {
						<span>{{breadcrumb.label | translate}}</span>
					}
				}
			</li>
		}
	</ol>
</nav>
